module.exports = __webpack_public_path__ + "assets/font/MiSans-Semibold-9e88ec36.woff2";